import { Omnichannel as o } from "./omnichannel.js";
import { RevenueAccelerate as r } from "./revenue-accelerate.js";
import { AdyenForPlatforms as m } from "./adyen-for-platforms.js";
import { AdyenForPlatformsAdvanced as t } from "./adyen-for-platforms-advanced.js";
import { AdyenForPlatformsLink as i } from "./adyen-for-platforms-link.js";
import { AdyenForPlatformsManage as e } from "./adyen-for-platforms-manage.js";
import { OilSplash as f } from "./oil-splash.js";
import { Network as p } from "./network.js";
import { Acquiring as a } from "./acquiring.js";
import { SchemeProducts as n } from "./scheme-products.js";
import { Gateway as u } from "./gateway.js";
import { Technology as c } from "./technology.js";
import { Recurring as l } from "./recurring.js";
import { Processing as h } from "./processing.js";
import { SmartRouting as s } from "./smart-routing.js";
import { Scalability as P } from "./scalability.js";
import { NoThirdParty as y } from "./no-third-party.js";
import { RevenueProtect as F } from "./revenue-protect.js";
import { RiskDanger as d } from "./risk-danger.js";
import { IdentityRisk as k } from "./identity-risk.js";
import { Knowledge as g } from "./knowledge.js";
import { Lock as C } from "./lock.js";
import { Security as S } from "./security.js";
import { Safe as O } from "./safe.js";
import { Checkout as A } from "./checkout.js";
import { CheckoutPayByLink as L } from "./checkout-pay-by-link.js";
import { CheckoutDropIn as R } from "./checkout-drop-in.js";
import { CheckoutComponents as w } from "./checkout-components.js";
import { CheckoutApiOnly as D } from "./checkout-api-only.js";
import { Platform as M } from "./platform.js";
import { PlatformGrowth as I } from "./platform-growth.js";
import { PlatformBusinessStructure as T } from "./platform-business-structure.js";
import { CoreDataStructure as b } from "./core-data-structure.js";
import { FinanceDataCore as v } from "./finance-data-core.js";
import { Partner as x } from "./partner.js";
import { LanguageLocalization as B } from "./language-localization.js";
import { MlPaymentOptimizationExperimentation as G } from "./ml-payment-optimization-experimentation.js";
import { PosMobile as U } from "./pos-mobile.js";
import { FormulaDifferentPeople as z } from "./formula-different-people.js";
import { FormulaGoodChoices as E } from "./formula-good-choices.js";
import { FormulaLaunchFast as N } from "./formula-launch-fast.js";
import { FormulaPickUpThePhone as q } from "./formula-pick-up-the-phone.js";
import { FormulaWinningIsMoreImportant as K } from "./formula-winning-is-more-important.js";
import { FormulaTalkStraight as W } from "./formula-talk-straight.js";
import { UnifiedCommerce as j } from "./unified-commerce.js";
import { FormulaBenefitMerchant as H } from "./formula-benefit-all-merchants.js";
import { FormulaCreateOwnPath as J } from "./formula-create-own-path.js";
import { Oauth as Q } from "./oauth.js";
import { OauthScalability as V } from "./oauth-scalability.js";
import { OauthAutomation as X } from "./oauth-automation.js";
import { OauthUserExperience as Y } from "./oauth-user-experience.js";
import { OauthSecurity as Z } from "./oauth-security.js";
const Zo = {
  Omnichannel: o,
  RevenueAccelerate: r,
  AdyenForPlatforms: m,
  AdyenForPlatformsAdvanced: t,
  AdyenForPlatformsLink: i,
  AdyenForPlatformsManage: e,
  OilSplash: f,
  Network: p,
  Acquiring: a,
  SchemeProducts: n,
  Gateway: u,
  Technology: c,
  Recurring: l,
  Processing: h,
  SmartRouting: s,
  Scalability: P,
  NoThirdParty: y,
  RevenueProtect: F,
  RiskDanger: d,
  IdentityRisk: k,
  Knowledge: g,
  Lock: C,
  Security: S,
  Safe: O,
  Checkout: A,
  CheckoutPayByLink: L,
  CheckoutDropIn: R,
  CheckoutComponents: w,
  CheckoutApiOnly: D,
  Platform: M,
  PlatformGrowth: I,
  PlatformBusinessStructure: T,
  CoreDataStructure: b,
  FinanceDataCore: v,
  Partner: x,
  LanguageLocalization: B,
  MlPaymentOptimizationExperimentation: G,
  PosMobile: U,
  FormulaDifferentPeople: z,
  FormulaGoodChoices: E,
  FormulaLaunchFast: N,
  FormulaPickUpThePhone: q,
  FormulaWinningIsMoreImportant: K,
  FormulaTalkStraight: W,
  UnifiedCommerce: j,
  FormulaBenefitMerchant: H,
  FormulaCreateOwnPath: J,
  Oauth: Q,
  OauthScalability: V,
  OauthAutomation: X,
  OauthUserExperience: Y,
  OauthSecurity: Z
};
export {
  Zo as Products
};
